const form = {
  formId: "form-organizadoor",
  formField: {
    cnpj: {
      name: "cnpj",
      label: "CNPJ",
      type: "text",
      errorMsg: "CNPJ é obrigatório",
      invalidMsg: "CNPJ deve ter 14 digitos",
    },
    cpf: {
      name: "cpf",
      label: "CPF",
      type: "text",
      errorMsg: "CPF é obrigatório",
      invalidMsg: "CPF deve ter 11 digitos",
    },
    nomeFantasia: {
      name: "nomeFantasia",
      label: "Nome Fantasia",
      type: "text",
      errorMsg: "Nome fantasia é obrigatório",
    },
    razaoSocial: {
      name: "razaoSocial",
      label: "Razão Social",
      type: "text",
      errorMsg: "Razão Soocial é campo obrigatório",
    },
    urlFacebook: {
      name: "urlFacebook",
      label: "URL Facebook",
      type: "text",
    },
    urlInstagram: {
      name: "urlInstagram",
      label: "URL Instagram",
      type: "text",
    },
    urlTwitter: {
      name: "urlTwitter",
      label: "URL Twitter",
      type: "text",
    },
    urlSite: {
      name: "urlSite",
      label: "URL Site",
      type: "text",
    },
    mediaSocialPageEvento: {
      name: "mediaSocialPageEvento",
      label: "Exibir mídia Social Page evento",
      type: "checkbox",
    },
    celPhone1: {
      name: "celPhone1",
      label: "Número Celular",
      type: "text",
      errorMsg: "Número do celular é campo obrigatório",
    },
    celPhone2: {
      name: "celPhone2",
      label: "Celular (Opcional)",
      type: "text",
    },
    telefone: {
      name: "telefone",
      label: "Telefone",
      type: "text",
    },
    email: {
      name: "email",
      label: "E-mail",
      type: "text",
      errorMsg: "E-mail é campo obrigatório",
      invalidMsg: "Endereço de email invalido.",
    },
    password: {
      name: "password",
      label: "Senha",
      type: "password",
      errorMsg: "Senha é compo obrigatório",
      invalidMsg: "A senha deve conter pelo menos 8 caracteres.",
    },
    confirmPassword: {
      name: "confirmPassword",
      label: "Confirmar senha",
      type: "password",
      errorMsg: "Senha confirmação obrigatório",
      invalidMsg: "A senha deve conter pelo menos 8 caracteres.",
    },
    cep: {
      name: "cep",
      label: "CEP",
      type: "text",
      errorMsg: "CEP é campo obrigatório",
    },
    logradouro: {
      name: "logradouro",
      label: "Logradouro",
      type: "text",
      errorMsg: "Logradouro é campo obrigatório",
    },
    numero: {
      name: "numero",
      label: "Número",
      type: "text",
      errorMsg: "Número é campo obrigatório",
    },
    bairro: {
      name: "bairro",
      label: "Bairro",
      type: "text",
      errorMsg: "Bairro é campo obrigatório",
    },
    cidade: {
      name: "cidade",
      label: "Cidade",
      type: "text",
      errorMsg: "Cidade é campo obrigatório",
    },
    uf: {
      name: "uf",
      label: "UF",
      type: "text",
      errorMsg: "UF é campo obrigatório",
    },
    complemento: {
      name: "complemento",
      label: "Complemento",
      type: "text",
    },
    tipoPessoa: {
      name: "tipoPessoa",
      label: "Tipo de pessoa",
      type: "text",
      errorMsg: "Tipo de pessoa é campo obrigatório",
    },
  },
};

export default form;
